import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import api from '../lib/api';
import { fehlertext } from '../lib/fehlertext';
import { toast } from 'sonner';

// Zeigt die letzten Absturzmeldungen aus den Browsern der Nutzer.
export const ClientErrors = () => {
  const [eintraege, setEintraege] = useState([]);
  const [laden, setLaden] = useState(false);

  const holen = async () => {
    try {
      setLaden(true);
      const res = await api.get('/admin/client-errors?limit=50');
      setEintraege(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      toast.error(fehlertext(e, 'Absturzmeldungen konnten nicht geladen werden'));
    } finally {
      setLaden(false);
    }
  };

  useEffect(() => { holen(); }, []);

  return (
    <Card data-testid="client-errors-card">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="flex items-center gap-2">
          <AlertTriangle className="h-5 w-5 text-amber-600" />
          Absturzmeldungen aus den Browsern
        </CardTitle>
        <Button variant="outline" size="sm" onClick={holen} disabled={laden} data-testid="client-errors-reload-button">
          <RefreshCw className={`h-4 w-4 mr-1 ${laden ? 'animate-spin' : ''}`} />
          Aktualisieren
        </Button>
      </CardHeader>
      <CardContent>
        {eintraege.length === 0 ? (
          <p className="text-sm text-slate-500" data-testid="client-errors-empty">Keine Meldungen vorhanden.</p>
        ) : (
          <div className="space-y-3" data-testid="client-errors-list">
            {eintraege.map((e) => (
              <div key={e.id} className="border border-slate-200 rounded-md p-3">
                <div className="flex flex-wrap gap-x-3 text-xs text-slate-500">
                  <span>{(e.created_at || '').replace('T', ' ').slice(0, 16)}</span>
                  <span>Seite: {e.page || '—'}</span>
                  {e.user_id ? <span>Nutzer: {e.user_id.slice(0, 8)}…</span> : <span>nicht angemeldet</span>}
                  <span>Version: {e.app_version || '—'}</span>
                  <span>Fenster: {e.viewport_w || '—'}×{e.viewport_h || '—'}</span>
                  <span>Sprache: {e.html_lang || '—'}</span>
                  <span>html-Klasse: {e.html_class || '—'}</span>
                </div>
                <p className="text-sm font-medium text-slate-900 mt-1 break-words">{e.message}</p>
                {(e.stack || e.component_stack || e.cause) && (
                  <details className="mt-1">
                    <summary className="text-xs text-slate-500 cursor-pointer">Technische Details</summary>
                    <pre className="mt-1 text-xs bg-slate-50 rounded p-2 overflow-auto max-h-48 whitespace-pre-wrap">
                      {[e.stack, e.component_stack, e.cause].filter(Boolean).join('\n\n')}
                    </pre>
                  </details>
                )}
                <p className="text-xs text-slate-400 mt-1 truncate">{e.user_agent}</p>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ClientErrors;
